import React from "react";
import "./Toasts.css";
import { useNotifications } from "../../contexts/NotificationContext";

function Toasts() {
  const { notifications, remove } = useNotifications();

  return (
    <div className="toasts-root">
      {notifications.map((n) => (
        <div key={n.id} className={`toast-card ${n.type}`}>
          <div style={{ flex: 1 }}>{n.message}</div>
          <div className="close-btn" onClick={() => remove(n.id)}>
            ✕
          </div>
        </div>
      ))}
    </div>
  );
};

export default Toasts;
